/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface CashDrawerRef
 */
export interface CashDrawerRefOptional {
  /**
   *
   * @type {string}
   * @memberof CashDrawerRef
   */
  cashDrawerId?: string;
}

export interface CashDrawerRef extends CashDrawerRefOptional {
  /**
   *
   * @type {string}
   * @memberof CashDrawerRef
   */
  cashDrawerId: string;
}

export interface CashDrawerRefTrackedI {
  /**
   *
   * @type {string}
   * @memberof CashDrawerRef
   */
  cashDrawerId?: string;
  cashDrawerIdIsSet: boolean;
}

transformDatesMap.set("CashDrawerRef", function (model: CashDrawerRef) {});

export type CashDrawerRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  cashDrawerId: PropertyMeta<MetaTypeBase<string>>;
}>;

export var CashDrawerRefMeta: CashDrawerRefMetaI = {} as CashDrawerRefMetaI;
CashDrawerRefMeta = typeMeta("CashDrawerRef", {
  cashDrawerId: propertyMeta(
    "cashDrawerId",
    false,
    true,
    true,
    MetaTypesBase.string,
  ),
});

const metaI = CashDrawerRefMeta;

registerMeta(() => {});

export class CashDrawerRefTracked implements CashDrawerRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  cashDrawerId__I?: string = undefined;

  get cashDrawerIdIsSet() {
    return this.cashDrawerId !== undefined;
  }
  set cashDrawerIdIsSet(v: boolean) {}
  set cashDrawerId(v: undefined | string) {
    if (v !== undefined) {
      this.cashDrawerId__I = v;
      this.cashDrawerIdIsSet = true;
    } else {
      this.cashDrawerId__I = v || undefined;
      this.cashDrawerIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get cashDrawerId() {
    return this.cashDrawerId__I;
  }
  constructor(config?: CashDrawerRefOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.cashDrawerIdIsSet == true && other?.cashDrawerIdIsSet == true)
      return this.cashDrawerId == other.cashDrawerId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.cashDrawerId) {
      this.cashDrawerIdIsSet = true;
    }
  }
  assignFrom(
    config: CashDrawerRefOptional,
    options?: AssignOptions,
  ): CashDrawerRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.cashDrawerId &&
      this.cashDrawerIdApplyFilter(optionsRequired.filter)
    ) {
      this.cashDrawerId = config.cashDrawerId;
      if (optionsRequired.unassign) this.cashDrawerIdIsSet = false;
      else this.cashDrawerIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CashDrawerRefTrackedI {
    const cloned = {} as CashDrawerRefTrackedI;
    if (
      this.cashDrawerIdIsSetDeep() &&
      this.cashDrawerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cashDrawerIdIsSet = true;
      cloned.cashDrawerId = this.cashDrawerId;
    } else {
      //cloned.cashDrawerIdIsSet = false
    }
    if (!isDeleted(this) && !this.cashDrawerIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CashDrawerRefTrackedI {
    if (!this.cashDrawerIdApplyFilter(filter)) this.cashDrawerIdIsSet = false;

    return this;
  }
  cashDrawerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawerRefMeta.cashDrawerId,
      CashDrawerRefMeta,
      this.cashDrawerId,
      this,
    );
  }
  cashDrawerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cashDrawerIdIsSet && this.cashDrawerIdApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.cashDrawerIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
